import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
@Component({
  selector: 'app-childcare-model',
  templateUrl: './childcare-model.component.html',
  styleUrls: ['./childcare-model.component.css'],
})
export class ChildcareModelComponent implements OnInit {
      @Input() benID:any
      @Input() AlraedyDataAdded:any
      
  childForm: FormGroup;
  imztnList: any[] = [];
  referredist: any[] = [];
  illnessList: any[] = [];
  nutritianList: any[] = [];
  treatmentList: any;
  enableOtherimmune: boolean;
  enableOtherIllness: boolean;
  enableTreatment: boolean;
  forPrescritionData: any

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.getImminization();
    this.getnutritian();
    this.getcommonillness();
    this.getTreatmentGiven();
    // this.getReferred();

      if(this.AlraedyDataAdded){
  setTimeout(() => {
    this.childForm.patchValue(this.AlraedyDataAdded)
    this.isOtherSelected(this.AlraedyDataAdded?.immune_given_id)
    this.isOtherSelectedIllness(this.AlraedyDataAdded?.common_illness_id)
    this.isOtherSelectedTreatment(this.AlraedyDataAdded?.treatment_given_id)
    

  }, 500);
  }
  }

  formInIt() {
    this.childForm = this.fb.group({
      immune_given_id: [],
      if_others_immune_given: [],
      nutrition_status_id: [],
      common_illness_id: [],
      if_others_common_illness: [],
      treatment_given_id: [],
      if_others_treatment_given: [],
      consult_refer_to_id: [],
      beneficiary_id:this.benID
    });
  }

    isOtherSelected(value:any) {
    if(value == '10'){
      this.enableOtherimmune =true
      // this.ancForm.get('gravida_para_id')?.setValue(null);
    }else{
       this.enableOtherimmune =false
      this.childForm.get('if_others_immune_given')?.setValue(null);
    }
   
  }
  isOtherSelectedIllness(value:any) {
    if(value == '7'){
      this.enableOtherIllness =true
      // this.ancForm.get('highrisk_reason_id')?.setValue(null);
    }else{
       this.enableOtherIllness =false
      this.childForm.get('if_others_common_illness')?.setValue(null);
    }
   
  }
  isOtherSelectedTreatment(value:any){
   if(value == '5'){
          this.enableTreatment = true
    }else{
        this.enableTreatment = false
      this.childForm.get('if_others_treatment_given')?.setValue(null);
    }

  }

  getImminization() {
    this.regService.get(`masters/masters/getallimmunizationgiven`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.imztnList = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  getnutritian() {
    this.regService.get(`masters/masters/getallnutritionstatus`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.nutritianList = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  getcommonillness() {
    this.regService.get(`masters/masters/getallcommonillness`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.illnessList = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  getTreatmentGiven() {
    this.regService.get(`masters/masters/getalltreatmentgiven`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.treatmentList = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  getReferred() {
    this.regService.get(`masters/masters/getallreferredto`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.referredist = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  onSave(){
    this.forPrescription();
    this.toastr.success("Records Saved After POC Submition")
    let data={
      "childForm" : this.childForm ,
      "forPrescritionData" : this.forPrescritionData
    }    
    setTimeout(() => {
      console.log('child Data',this.childForm.value)
      this.activeModal.close(data)
    }, 200);
   
  }


  forPrescription(){
    this.forPrescritionData = {

      immune_given_id: this.imztnList.find( (e: any) => e.id == this.childForm.value.immune_given_id)?.name || '',
      if_others_immune_given: this.childForm.value.if_others_immune_given,
      nutrition_status_id: this.nutritianList.find( (e: any) => e.id == this.childForm.value.nutrition_status_id)?.name || '',
      common_illness_id:this.illnessList.find( (e: any) => e.id == this.childForm.value.common_illness_id)?.name || '',
      if_others_common_illness:this.childForm.value.if_others_common_illness,
      treatment_given_id: this.treatmentList.find( (e: any) => e.id == this.childForm.value.treatment_given_id)?.name || '',
      if_others_treatment_given:this.childForm.value.if_others_treatment_given,
      consult_refer_to_id: null,
      beneficiary_id:this.benID
    }

    // Check all relevant values
     const isPrescrEmpty = Object.entries(this.forPrescritionData).filter(([key, value]) =>
      key !== 'beneficiary_id' && !(key.endsWith('_id') && value === 0) )
      .every(([_, value]) => value === null || value === '' || value === undefined);

       if (isPrescrEmpty) {
         this.forPrescritionData = null;
      }

  }
}
